<template>
  <div>
    <CourseDetail :packageId="packageId"></CourseDetail>
  </div>
</template>

<script>
import CourseDetail from "./courseDetail";
export default {
  name: "coursePackage",
  data() {
    return {
      packageId: "",
    };
  },
  components: {
    CourseDetail,
  },
  beforeRouteEnter(to, from, next) {
    next((_this) => {
      if (from.path == "/h5/common/paySuccess") {
        if (sessionStorage.getItem("courseid")) {
          _this.packageid = sessionStorage.getItem("packageId");
          sessionStorage.removeItem("packageId");
          var url = "/#/h5/course/coursePackage?packageId=" + _this.packageId;
          history.replaceState({ packageId: _this.packageId }, "", url);
          _this.$router.go(0);
        }
      }
    });
  },
  created () {
       this.packageId = this.$route.query.packageId? this.$route.query.packageId: "";
  },
  mounted() {
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>